import FlexiText from "slotworks/graphics/elements/flexi-text";
import { ToggleEvent } from "slotworks/graphics/elements/flexi-toggle";
import Layers from "slotworks/graphics/layers/layers";
import RegulationsModel from "slotworks/model/regulations/regulations-model";
import AbstractToggleControl from "slotworks/smart-ui/controls/abstract/abstract-toggle-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class TurboToggleControl extends AbstractToggleControl implements Control {

    private label: FlexiText;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.label = layer.getFlexiText("turbo_toggle_label");

        this.toggle.on(ToggleEvent.CHANGE, this.onChangeHandler);

        this.setVisible(true);
    }

    public setVisible(visible: boolean) {
        this.setComponentsVisible(visible && RegulationsModel.turboAllowed);
    }

    public updateOptions(options: ControlOptions) {
        if (RegulationsModel.turboAllowed) {
            this.toggle.setValue(options.turboSpin);
            this.setVisible(true);
        }
    }

    protected onChangeHandler = (value: boolean) => {
        const options = new ControlOptions();
        options.turboSpin = !value;

        this.onChange.dispatch(options);
    }

    private setComponentsVisible(visible: boolean): void {
        super.setVisible(visible);
        if (this.label) {
            this.label.setVisible(visible);
        }
    }
}
